// Rails CSRF wiring for axios, imported once for side effects by both packs
// (packs/ui.tsx and the legacy application pack). Both share the vendor
// chunk, so this is the single writer of the axios defaults.
//
// Safe at import time: pack scripts are deferred, so the <meta> tag in <head>
// is already parsed when this runs.
import axios from 'axios';

const csrfMeta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
if (csrfMeta) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfMeta.content;
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}
